import { render, staticRenderFns } from "./ConfirmDeleteAssistAssoc.vue?vue&type=template&id=0bd41c16&"
import script from "./ConfirmDeleteAssistAssoc.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteAssistAssoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports